import { Injectable ,InjectionToken } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js';
import { defaultLanguage } from 'src/app/app.default.language';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../api/api.service';
import { Location, PopStateEvent } from "@angular/common";
import { NavigateService } from '../navigate/navigate.service';
import { url } from 'inspector';
 

@Injectable({
  providedIn: 'root'
})
export class UtilitysService {

  private profilePromise: Promise<any> | null = null;

  constructor(
    private api: ApiService,
    private router: Router, 
    private location: Location,
    private navigate: NavigateService,
    private translateService: TranslateService
  ) {
  }

  getMyProfile(isCheckPhone = true, isCheckEmail = true, suppressRedirect = false, forceRefresh = false): Promise<any> {
    if (forceRefresh) {
      this.profilePromise = null;
    }
    
    if (this.profilePromise) {
      return this.profilePromise;
    }

    if (!this.api.token) {
        this.api.updateTokens();
    }

    this.profilePromise = new Promise((resolve, reject) => {
      this.api.getMyProfile2(this.api.token.toString(), suppressRedirect, forceRefresh).subscribe((res: any) => {
        if (res && res.Code === 200) {
          if(isCheckPhone && !res.Results.Phone){
            this.navigate.navigateMenu('signin?reset=phone', true);
          } else if(isCheckEmail && !res.Results.Email) {
            this.navigate.navigateMenu('signin?reset=email', true);
          } else {
            resolve(res.Results);
          }
        } else {
           reject(res);
        }
        this.profilePromise = null;
      }, err => {
        reject(err);
        this.profilePromise = null;
      });
    });
    return this.profilePromise;
  }

  getText(key?: any, config?: ReplaceValue): Promise<any> {
    return new Promise(async (resovle) => {
      let msg = await this.translateService.get(key).toPromise();
      if (msg == key || msg.length == 0) {
        msg = defaultLanguage[key];
      }

      config.replaces.forEach(n => {
        msg = msg.replace(n.k, n.v);
      });

      resovle(msg);
    });
  }

  formatCount(num: number): string {
    if (num === null || num === undefined) return '0';
    const mSuffix =  'M';
    const kSuffix =  'K';

    if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + mSuffix;
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + kSuffix;
    return num.toString();
  }

  reloadScroll() {
    let lastPoppedUrl: string;
    let yScrollStack: number[] = [];
    this.location.subscribe((ev:PopStateEvent) => {
        lastPoppedUrl = ev.url;
    });
    
    this.router.events.subscribe((ev:any) => {
        if (ev instanceof NavigationStart) {
            if (ev.url != lastPoppedUrl)
                yScrollStack.push(window.scrollY);
        } else if (ev instanceof NavigationEnd) {
            if (ev.url == lastPoppedUrl) {
                lastPoppedUrl = undefined;
                window.scrollTo(0, yScrollStack.pop());
            } else
                window.scrollTo(0, 0);
        }
    });
  }
}


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  secureKey = 'work_plus_web';
  storageName = 'w_p_w_';

  constructor(){}//private appsetting: AppsettingService) { }

  getItem(key: string) {
    return this.decrypt(window.localStorage.getItem(this.storageName + key) || null);
  }

  async setItem(key: string, value: any) {
    //const config: any = await this.appsetting.get();
    window.localStorage.setItem(this.storageName + key, this.encrypt(value));
    // if (
    //   config.baseURL + '/companyCode' === key ||
    //   config.baseURL + '/profile' === key
    // ) {
    //   window.localStorage.setItem(this.storageName + key + '_desk', this.Encryption(value));
    // }

  }

  removeItem(key: string) {
    window.localStorage.removeItem(this.storageName + key);
  }

  clear() {
    window.localStorage.clear();
  }

  encrypt(value: any) {
    return CryptoJS.AES.encrypt(value, this.secureKey).toString();
    // return value;
  }

  decrypt(value: any) {
    return value ? CryptoJS.AES.decrypt(value, this.secureKey).toString(CryptoJS.enc.Utf8) : null;
    //return value;
  }

  Encryption(number) {

    const key = CryptoJS.enc.Utf8.parse('work_plus_web_ds');
    const iv = CryptoJS.enc.Utf8.parse('work_plus_web_ds');
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(number), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

}

@Injectable({
  providedIn: 'root'
})
export class HyperLinkService {

  private handleEvents: EventListener;
  private handleHashtagEvents: EventListener;

  constructor(
    private router: Router,
    //private storage: StorageService,
    // private coreBrowserService: CoreBrowserService,
    // private coreEventsService: CoreEventsService,
    private sanitizer: DomSanitizer,
    private api: ApiService,
    //private appsetting: AppsettingService

  ) { }

  private bindingEventURLdetect(element: any) {
    // console.log(element)
    // Query the DOM to find ALL occurrences of the <a> hyperlink tag
    const urls: any = element.nativeElement.querySelectorAll('a');

    // Iterate through these
    urls.forEach((url: any) => {
      // // console.log(url);
      url.click = null;

      // Listen for a click event on each hyperlink found
      url.removeEventListener('click', this.handleEvents, false);
      url.addEventListener('click', this.handleEvents, false);

    });

  }

  detectURL(element: any) {

    this.handleEvents = (event) => this.openURL(event);

    setTimeout(() => {
      this.bindingEventURLdetect(element);
    }, 100);

  }

  async openURL(event: any) {
    // Retrieve the href value from the selected hyperlink 
    event.preventDefault();
    let link =
      (event.target.href && event.target.href.indexOf('http') !== -1) ? event.target.href :
        (event.target.innerText && event.target.innerText.indexOf('http') !== -1) ? event.target.innerText :
          (event.target.name && event.target.name.indexOf('http') !== -1) ? event.target.name : '';

    // Log values to the console and open the link within the InAppBrowser plugin
    // //// console.log('Name is: ' + event.target.innerText);
    //// console.log('Link is: ' + link);
    if (!link) { return; }
    //link = await this.replaceURLFormat(link);
    window.open(link, '_blank');
  }

  detectURLToHTML(text: string) {
    const str = text.replace(/(<a href=")?((https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)))(">(.*)<\/a>)?/gi, (link: string) => {
      return `<a id="link" href="${link}" class='link-caption' target='_blank' name="${link}">${link}</a>`;
    });
    return str;
  }

  detectHashtag(element: any) {

    this.handleHashtagEvents = (event) => this.openHashtag(event);

    setTimeout(() => {
      this.bindingEventHashtagDetect(element);
    }, 100);

  }

  bindingEventHashtagDetect(element: any) {
    // Query the DOM to find ALL occurrences of the <span class="hashtah"> tag
    const eles: any = element.nativeElement.querySelectorAll('span.hashtag');

    // Iterate through these
    eles.forEach((ele: any) => {
      // // console.log(url);
      ele.click = null;
      // Listen for a click event on each hyperlink found
      ele.removeEventListener('click', this.handleHashtagEvents, false);
      ele.addEventListener('click', this.handleHashtagEvents, false);
    });
  }

  openHashtag(event: any) {
    // Retrieve the href value from the selected hyperlink
    event.preventDefault();
    // this.coreEventsService.publish('SelectHashtag', event.target.innerText);
    this.router.navigateByUrl('/exp-hashtag/' + event.target.innerText);
  }

  detectURLToArr(text: string) {
    const links = [];

    if (!text) {
      return;
    };

    text.replace(/(<a href=")?((https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)))(">(.*)<\/a>)?/gi, (link: string) => {
      const match = link.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);

      if (match && match[7].length === 11) {
        links.push('https://www.youtube.com/embed/' + match[7]);
      }

      return '';
    });
    return links;
  }
  // WORKPLUS CUSTOM
  // async replaceURLFormat(URL: string) {
  //   const config: any = await this.appsetting.get();
  //   const companyCode = this.storage.getItem(config.baseURL + '/companyCode');
  //   const token = this.storage.getItem(config.baseURL + '/token');
  //   const accessToken = this.storage.getItem(config.baseURL + '/accessToken');
  //   const tokenType = this.storage.getItem(config.baseURL + '/tokenType');
  //   const profile = JSON.parse(this.storage.getItem(config.baseURL + '/profile'));

  //   URL = URL.replace(/__appToken__/, config.automateAppToken);
  //   URL = URL.replace(/__token__/, token);
  //   URL = URL.replace(/__accessToken__/, accessToken);
  //   URL = URL.replace(/__tokenType__/, tokenType);

  //   URL = URL.replace(/__userId__/, (profile.UserId || profile.Id));
  //   URL = URL.replace(/__email__/, profile.OfficeEmail);
  //   URL = URL.replace(/__empId__/, profile.EmployeeId);
  //   URL = URL.replace(/__companyCode__/, companyCode);

  //   URL = await this.api.requestOneTimeToken(URL);


  //   return URL;
  // }
  replaceMentionHTML(memberSelected: any[], text: string) {
    let caption = JSON.parse(JSON.stringify(text));
    const mention = [];
    memberSelected.forEach((member: any, index) => {
      if (caption.indexOf(member.FullName || member.Name) !== -1) {
        const re = new RegExp((member.FullName || member.Name), 'g');
        const color =
          // this.coreService.variables._theme === 'light'
          false ? 'rgba(197, 226, 255,1);' : 'rgba(88, 88, 88,1);';
        mention.push({
          'html': `<mark class="hl-caption">${member.FullName || member.Name}</mark>`
        });
        caption = caption.replaceAll(re, `{` + index + `;}`);
      }
    });

    mention.forEach((element, index) => {
      caption = caption.replaceAll(`{` + index + `;}`, element.html);
    });

    return caption ? this.sanitizer.bypassSecurityTrustHtml(caption) : '';
  }
  replaceMentionFeedHTML(memberSelected: any[], text: string, isLastComment = false) {
    let caption = JSON.parse(JSON.stringify(text));

    if (caption) {
      const mention = [];
      var allMember = [];
      memberSelected.forEach((member: any, index) => {
        var has = allMember.find(res => {
          return res == member.UserId
        });

        if (caption.indexOf(member.FullName || member.Name) !== -1) {
          allMember.push(member.UserId);
          const re = new RegExp((member.FullName || member.Name), 'g');
          const color =
            // this.coreService.variables._theme === 'light'
            false ? 'rgba(197, 226, 255,1);' : 'rgba(88, 88, 88,1);';
          if (!has) {
            mention.push({
              'userid': member.UserId,
              'html': `<a class="hl-caption-feed exp-tags mention" mention="${member.UserId}"    userid='${member.UserId}' >${member.FullName || member.Name}</a>`
            });
            caption = caption.replaceAll(re, `{` + member.UserId + `;}`);
          }

        }

      });
      caption = caption.replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;');
      mention.forEach((element, index) => {
        caption = caption.replaceAll(`{` + element.userid + `;}`, element.html);
      });


      // if (isLastComment) {
      // caption = this.sanitizer.bypassSecurityTrustHtml(caption)

      // }
    }
 
    return (caption !== null && caption !== undefined) ? caption : '';
  }

  bypassSecurityTrustHtml(txt) {
    return this.sanitizer.bypassSecurityTrustHtml(txt);
  }

}

@Injectable({
  providedIn: 'root',
})
export class CoreTranslateService {
  constructor(private translate: TranslateService) {}

  open() {
    // this.core.utility.modal.open({
    //     component: LanguageModalComponent,
    //     data: null,
    //     config: null,
    // });
  }

  getLang() {
    return this.translate.currentLang;
  }
  setDefaultLang() {
    // this.translate.setDefaultLang('th');
    // this.translate.setDefaultLang('en');
  }

  getWord(key: string): string {
    if (!key) {
      return '';
    }
  
    const map = this.translate.store.translations[this.translate.currentLang];
    // const word = map[key] || key;
    //   return word;
  
    if (!map) {
      return key;
    }
  
    // รองรับ flat key เช่น "TRANSLATE.th"
    if (map.hasOwnProperty(key)) {
      const flatValue = map[key];
      if (typeof flatValue === 'string') {
        return flatValue;
      }
    }
  
    // ถ้าไม่เจอ flat key ลองค้นหาแบบ nested key
    const keys = key.split('.');
    let word: any = map;
  
    for (const k of keys) {
      if (word && word.hasOwnProperty(k)) {
        word = word[k];
      } else {
        return key; // ไม่พบ key ระหว่างทาง
      }
    }
  
    return typeof word === 'string' ? word : key;
}

  async use(key: string) {
    // console.log('key', key);
    await this.translate.use(key).toPromise();
    localStorage.setItem('language', key);
  }
}

@Injectable({ providedIn: 'root' })
export class TranslationInitService {
  constructor(private coreTranslate: CoreTranslateService) {}

  initTranslation(): Promise<any> {
    const lang = localStorage.getItem('language') || 'th';
    return this.coreTranslate.use(lang); // รอโหลดภาษาก่อน bootstrap
  }
}

export interface Config {
  replaces: Array<{ k, v }>;
}


export interface ReplaceValue {
  replaces: Array<{ k, v }>;
}
